import { CreateResponsiveStyle,DEVICE_SIZES, useDeviceSize,} from "rn-responsive-styles";
import { FONTS,COLORS } from "../constant";

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    containerTimer: {
    backgroundColor: "rgba(91, 91, 91, 0.56)",
     position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: 99999,
      // right:100,
      // top:'30%'
    },
    overlayTimer: {
     // backgroundColor: "rgba(117, 91, 91, 0.9)",
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    loaderBgTimer: {
      backgroundColor: "white",
      //width: '50%',
      // height:'50%',
      width: 350,
      height: 270,
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    containerLoader: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.5)',
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: 99
    },
    spinnerOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent dark background
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000, // ensure it's above everything else
      backdropFilter: "blur(4px)", // ❗ works only on web with CSS
    },
    
    spinnerBox: {
      width: 323,
      height: 222,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 0.2, // was `20` by mistake, needs to be between 0 and 1
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1001,
    },
    spinner: {
      marginTop:  25,
      marginBottom:  15,
      transform: [
        { scaleX: 1 },
        { scaleY: 1 }, 
      ],
    },
    filterWrapper:{
      flexDirection:"row",
      // maxWidth:"100%"
      width:"39%",
      gap:10
    },
    headerContent : {
      width: "90%",
      height: 100,
      borderRadius: 10,
      backgroundColor: "#d6d6d6",
      flexDirection:"row",
      padding:20,
      gap:20,
      minWidth: 300,
      zIndex: 1,

    },
    verticalLine : {
      width: 2,
      height: 57.2,
      backgroundColor: "#eaeaea"
    },
    filterButtonWrapper:{
      width: 89.6,
      height: 31.8,
      borderRadius: 6,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#e4e4e4",
      flexDirection:"row",
      padding:10,
      alignItems:"center", 
      gap:30
    },
    downloadBtnWrapper:{
      width: 246,
      height: 33,
      borderRadius: "15px",
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#dededf",
      flexDirection:"row",
      padding:10,
      alignItems:"center", 
      gap:10
    },

    btnStyle:{
      justifyContent: "center",
      height: 35.7,
      paddingHorizontal: 20,
      borderRadius: 18,
      backgroundColor: "transperant",
      borderWidth: 2,
      borderColor: "#fff",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },

    clickedBtnStyle:{
      width: 150,
      height: 35.7,
      backgroundColor: "#f4d8cf",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#9b1e26",
      borderRadius: 18,
      flexDirection:"row",
      gap:20,
      justifyContent: "center",
      // padding: 10,

    },
    creditwrapper:{
      flexDirection:"row",
      justifyContent: "center",
      alignItems:"center",
      // padding:10,
      gap:35,
      width: 245,
      height: 33,
      borderRadius: 15,
      backgroundColor: "#e9e9e9",
    },
    creditwrapperd:{
      flexDirection:"row",
      justifyContent: "center",
      alignItems:"center",
      // padding:10,
      gap:35,
      width: 245,
      height: 33,
      borderRadius: 15,
      backgroundColor: "#e9e9e9",
      marginLeft:-30
    },
    activeFilter:{
      fontFamily: FONTS.InterBold,
      fontWeight: "600",
      fontSize:14,
      color:COLORS.maroon,
      backgroundImage: 'linear-gradient(to right, #971D25, #58070C)',
      color:"white",
      width:"30%",
      height:33,
      lineHeight:33,
      borderRadius:15,
      marginLeft:-11,
      // marginRight:-40,
      textAlign:"center"},
    verticalLineDownload:{
      width: 1,
      height: 29.2,
      backgroundColor: "#dedede"
    },
    activeDownloadFilter:{
      fontFamily: FONTS.InterBold,
      fontWeight: "600",
      fontSize:10,
      color:COLORS.maroon,
      backgroundImage: 'linear-gradient(to right, #971D25, #58070C)',
      color:"white",
      width:"70%",
      height:23,
      lineHeight:23,
      borderRadius:15,
      // marginLeft:-11,
      // marginRight:-40,
      textAlign:"center",
      alignItems:"center",
      justifyContent:"center"
    },
      inactiveDownloadFilter: {
      color: "#999",
      fontFamily: FONTS.InterBold,
      fontWeight: "600",
      fontSize:10,
      color:"white",
      width:"60%",
      height:23,
      lineHeight:23,
      borderRadius:15,
      // marginLeft:-11,
      // marginRight:-40,
      textAlign:"center",
      alignItems:"center",
      justifyContent:"center"
    },

    creditSelectedOption:{
      width: 100,
      height: 30,
      borderRadius: 15,
      backgroundColor: "#9b1e26"
    },
    calenderWrapper:{
      width: 345,
      height: 109,
      borderRadius: 8,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#dededf",
      alignContent:'center'
    },
    calenderInput:{
      flexDirection:"row",
      justifyContent: "space-between",
      padding:10,
      width: 345,
  height: 39.4,
  borderRadius: 8,
  backgroundColor: "#ffffff",
  borderStyle: "solid",
  borderWidth: 1,
  borderColor: "#dededf",
  fontSize:14
    },
    inputContainer: {
      width: 165,
      marginVertical: 5,
    },
    input: {
      backgroundColor: "#F1F2F4",
      borderRadius: 10,
      height: 30,
      paddingHorizontal: 20,
    },
    dropdownStyle: {
      borderWidth: 2,
      borderTopWidth: 1,
      borderColor: "blue",
      minHeight: 50,
      maxHeight: 130,
      position: "absolute",
      zIndex: 9999,
      width: "100%",
      borderBottomRightRadius: 10,
      borderBottomLeftRadius: 10,
      marginTop: 30,
      backgroundColor: "white",
    },
    

    mainContainer: {
      width: "100%",
      height:'100%',
      flexDirection:'row',
      paddingTop:40,
      justifyContent:'center',
      backgroundColor:'#f2f4f5',
      backgroundImage:
      "linear-gradient(to top, #f2f4f5, #f2f4f5 50%, #eee 50%, #333 50%);",
    },
    dropDownWrapper:{
      flexDirection: "row",
      width: "100%",
      alignItems: "center",
      marginTop: 9,
      justifyContent: "space-between",
    },
    minAmountText:{
      fontSize: 13,
      color: "#fff",
      textAlign: "right",
    },
    contentWidget:{
      maxWidth:1200,
      width:'100%',
      flexDirection:'row',
    },
    container: {
      flex: 1,
      width: "100%",
      paddingHorizontal: 60,
    },
    radioButtonWrapper: {
      flexDirection: "row",
      alignItems: "flex-start",
      paddingTop: 20,
      position: "relative",
      zIndex: 999,
    },
    radioWidget: {
      paddingTop: 4,
      flexDirection: "column",
      justifyContent: "flex-start",
    },
    text: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#fff",
      marginRight: 50,
      paddingTop: 16,
    },
    nodataViewStyle: {
      width: "90%",
      backgroundColor: "#fff",
      borderRadius: 10,
      zIndex:-1
    },
    datePickerContainer: {
      flexDirection: "row",
      marginTop:10,
      backgroundColor: "black",
    },
    datePickerWrapper: {
      flexDirection: "column",
      marginLeft: -40,
      paddingTop: 14,
      
    },
    emptySpace: {
      minWidth: 200,
    },
    dateText: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#fff",
      marginRight: 20,
      marginBottom: 12,
    },
    datePicker: {
      backgroundColor: "#fff",
      borderRadius: 6,
      height: 35,
      padding: 5,
      display:"none",
      width:100
    },
    radioDescWidget: {
      flexDirection: "row",
    },
    dropDownText: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#fff",
      marginRight: 15,
    },
    dropDownWidget: {
      flexDirection: "row",
      zIndex: 9999,
      position: "relative",
      zIndex: 9999,
    },
    radioDesc: {
      fontFamily: "Inter",
      fontSize: 13,
      color: "#fff",
      marginRight: 20,
      opacity: 0.6,
      width: "35%",
    },
    buttonsWrapper: {
      flexDirection: "row",
      marginTop: 20,
      marginBottom: 20,
      gap:20,
      zIndex:-1
    },
    btnBox: {
      marginRight: 20,
      marginTop:20
    },
    dropDownHeader: {
      backgroundColor: "#fff",
      width: 300,
      height: 40,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      paddingHorizontal: 15,
      borderBottomWidth: 1,
      borderColor: "rgba(37, 36, 59, 0.4)",
    },
    dropDownHeaderHide: {
      backgroundColor: "#fff",
      width: 300,
      height: 40,
      borderRadius: 10,
      paddingHorizontal: 15,
      borderBottomWidth: 1,
      borderColor: "rgba(37, 36, 59, 0.4)",
    },
    showDropdown: {
      display: "flex",
      backgroundColor: "#fff",
      borderColor: "#dfdfdf",
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      height: 200,
      overflow: "scroll",
      width: 300,
      position: "absolute",
      top: 50,
      zIndex: 10,
    },
    btnBorderStyle: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      alignSelf: "center",
      height: 35.7,
      paddingHorizontal: 20,
      borderRadius: 18,
      backgroundColor: "transparent",
      borderWidth: 2,
      borderColor: "#fff",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    noteTextWidget: {
      flexDirection: "row",
      justifyContent: "space-between",
      maxWidth: 990,
    },
    noteText: {
      fontFamily: "Inter",
      fontSize: 10,
      color: "#d6d6d6",
      marginVertical: 15,
    },
    filterTextWidget: {
      flexDirection: "row",
      alignItems: "center",
    },
    filterText: {
      fontFamily: "Inter",
      fontSize: 12,
      color: "#fff",
    },
    iconFilter: {
      width: 30,
      height: 30,
      marginLeft: 10,
    },
    rowStyle: {
      width: 100,
      minWidth: 100,
      paddingHorizontal: 10,
      marginVertical: 5,
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 30,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
    },
    headerTextStyle: {
      width: 100,
      height: 60,
      minWidth: 100,
      paddingHorizontal: 10,
      marginVertical: 5,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.99,
      textAlign: "left",
      color: "#66625f",
      paddingTop: 10,
    },
    verticalLineStyle: {
      width: 0.5,
      height: "100%",
      backgroundColor: "#a0a0a0",
    },
    headerViewStyle: {
      flexDirection: "row",
      backgroundColor: "#ffffff",
      borderTopRightRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomWidth: 0.5,
      borderColor: "#a0a0a0",
    },
    dataViewStyle: {
      flexDirection: "row",
    },
    dataTable: {
      height: 700,
      marginHorizontal: 50,
      width: 1200,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
    overlayViewStyleAlert: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
    overlayViewStyleFilter: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "90%",
      height: 429,
      bottom: 0,
      left: 0,
      borderRadius: 10,
    },
    modalHeader: {
      flexDirection: "row",
      paddingVertical: 12,
      paddingHorizontal: 30,
      alignItems: "center",
    },
    filterTitle: {
      flexDirection: "row",
      marginRight: 200,
      alignItems: "center",
    },
    filterRadioWidget: {
      flexDirection: "row",
    },
    statementTypeWidget: {
      marginTop: 34,
      marginHorizontal: 40,
      marginBottom: 30,
    },
    statementTypeWidgetLeft: {
      marginTop: 34,
      marginRight: 140,
      marginBottom: 30,
      marginLeft: 40,
    },
    footerWidget: {
      flexDirection: "row",
    },
    circle23: {
      width: 20,
      height: 20,
      borderRadius: 10,
      borderColor: "rgba(255,255,255,0.6)",
      borderWidth: 2,
      alignItems: "center",
      justifyContent: "center",
      marginRight: 8,
    },
    circleText: {
      color: "rgba(255,255,255,0.6)",
      fontSize: 14,
      marginTop: -3,
    },
    iconNoResult: {
      width: 100,
      height: 100,
      marginBottom: 30,
    },
    titleNoResult: {
      fontFamily: "Inter",
      fontSize: 21,
      fontWeight: "600",
      color: "#5f5f5f",
      marginBottom: 5,
    },
    descNoResult: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "600",
      color: "#757575",
      textAlign:'center'
    },
    transactionAmountWidget:{ 
      marginHorizontal: 40,
       minWidth: 310 
    }
  },

  {
    [DEVICE_SIZES.XL]: {
      container: {
        maxWidth: 1320,
      },
      
    },
    [DEVICE_SIZES.LG]: {
      container: {
        maxWidth: 1140,
      },
      dataTable: {
        width: 800,
      },
   
    },
    [DEVICE_SIZES.MD]: {
      container: {
        maxWidth: 960,
      },
      dataTable: {
        height: 649,
        width: 528,
      },
      buttonsWrapper:{flexDirection:"col",flexWrap:"wrap"},
      headerContent:{ flexWrap: "wrap",height: 300},
      radioButtonWrapper: {
        flexDirection: "column",
      },
      datePickerContainer: {
        marginLeft: 40,
      },
      emptySpace: {
        minWidth: 0,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {},
      dataTable: {
        width: 528,
        height: 649,
      },
      radioButtonWrapper: {
        flexDirection: "column",
      },
      datePickerContainer: {
        marginLeft: 40,
      },
      emptySpace: {
        minWidth: 0,
      },
      buttonsWrapper: {
        flexDirection:"col",
        flexWrap: "wrap",
      },
      headerContent:{ flexWrap: "wrap",height: 300},
      footerWidget: {
        flexDirection: "column",
      },
      overlayViewStyleAlert:{
        width:390,
        marginLeft:-20,
        top:-100,
        height:'120%'
      },
      overlayViewStyleFilter:{
        width:'100%',
        height:460,
        bottom:'10%'
      },
      statementTypeWidgetLeft:{
        marginRight:40
      },
      transactionAmountWidget:{
        minWidth:260
      }
    },
    [DEVICE_SIZES.XS]: {
      mainContainer:{
        paddingLeft:15,
        paddingTop:20
      },
      calenderInput:{
        width:290
      },
      calenderWrapper:{
        marginLeft:-30
      },
      filterWrapper:{
        width:'90%',
        flexWrap:'wrap'
      },
      container: {
        paddingHorizontal: 0,
        marginLeft: -60,
      },
      dataTable: {
        width: "96%",
        height: 949.5,
        marginHorizontal: 0,
      },
      radioButtonWrapper: {
        flexDirection: "column",
        paddingTop: 0,
      },
      datePickerWrapper: {
        position: "relative",
        top: 5,
        right: 0,
        left: 40,
      },
      emptySpace: {
        minWidth: 0,
      },
      buttonsWrapper: {
        flexDirection:"col",
        flexWrap: "wrap",
      },
      headerContent:{ flexWrap: "wrap",height: 250,width: "96%"},
      verticalLine:{display:"none"},
      dropDownWrapper:{width:"100%"},
      footerWidget: {
        flexDirection: "column",
      },
      dropDownHeader: {
        width: 290,
      },
      dropDownHeaderHide: {
        width: 290,
      },
      showDropdown: {
        width: 290,
      },
      radioWidget: {
        width: "100%",
      },
      nodataViewStyle: {
        width: "100%",
      },
      dropDownWidget: {
        flexDirection: "column",
      },
      dropDownText: {
        paddingBottom: 5,
      },
      overlayViewStyleAlert:{
        width:360,
        marginLeft:-20,
        top:-100,
        height:'120%'
      },
      overlayViewStyleFilter:{
        width:'100%',
        height:460,
      },
      statementTypeWidgetLeft:{
        marginRight:40
      },
      transactionAmountWidget:{
        minWidth:260
      },
      creditwrapperd:{
        flexDirection:"row",
        justifyContent: "center",
        alignItems:"center",
        // padding:10,
        gap:35,
        width: 245,
        height: 33,
        borderRadius: 15,
        backgroundColor: "#e9e9e9",
        marginLeft:0,
        
      },
    },
  }
);

//make this component available to the app
export default useStyles;

